import React, { memo, useCallback } from 'react';
import { Snackbar as SnackbarBase } from '@cognitiv/cyprus-ui';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { selectSettings } from 'ducks/settings/selectors';
import { updateSettings } from 'ducks/settings/slices';
import { useSwitchTheme } from 'hooks/useSwitchTheme';

const SnackbarMemo = () => {
  const dispatch = useAppDispatch();
  const { theme } = useSwitchTheme();
  const { snackbar_label, snackbar_action, snackbar_duration, snackbar, sw_registration } =
    useAppSelector(selectSettings);

  const updateServiceWorker = useCallback(() => {
    const registrationWaiting = sw_registration?.waiting;
    if (registrationWaiting) {
      dispatch(updateSettings({ loading: true }));
      registrationWaiting?.postMessage({ type: 'SKIP_WAITING' });

      registrationWaiting.addEventListener('statechange', (e) => {
        const sw = e?.target as ServiceWorker;
        if (sw?.state === 'activated') {
          window.location.reload();
        }
      });
    }
  }, [dispatch, sw_registration?.waiting]);

  const onSnackbar = useCallback(() => {
    if (snackbar_action) {
      updateServiceWorker();
    }
    dispatch(
      updateSettings({
        snackbar: false,
        snackbar_variant: 'secondary',
        snackbar_action: null,
        snackbar_label: null,
        snackbar_duration: null,
      }),
    );
  }, [dispatch, snackbar_action, updateServiceWorker]);

  const snackbarClose = useCallback(() => {
    dispatch(
      updateSettings({
        snackbar: false,
        snackbar_variant: 'secondary',
        snackbar_action: null,
        snackbar_label: null,
        snackbar_duration: null,
      }),
    );
  }, [dispatch]);
  if (!snackbar_label || !snackbar) return null;

  return (
    <SnackbarBase
      show={snackbar}
      width="max-content"
      theme={{
        snackbar_background: theme.snackbar.snackbar_background,
        action_snackbar_color: theme.snackbar.snackbar_font_color_hover,
      }}
      label={snackbar_label}
      duration={snackbar_duration}
      action={snackbar_action}
      onChange={onSnackbar}
      onClose={snackbarClose}
      icon_color="#276EF1"
    />
  );
};

export const Snackbar = memo(SnackbarMemo);
